import {call, put, takeLatest, fork, all, delay,} from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as AirportService from './../services/airportService';

import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import {PATHS, SAGA_DELAY_TIMEOUT} from '../constants/Define';
import { parseListRequestParamsCameo } from '../utils/commonUtils';
import {
    setListAirports as setListAirportsAction,
    setAirportDetail as setAirportDetailAction,
    setListAirportDeparture,
    setListAirportArrival,
    setListAirlineDomestic,
    setToAirportList,
    updateToAirportList,
    setAirlineSourceVJ,
} from './../actions/airportAction';
import history from './../helpers/history';

function* getListAirport() {
    yield takeLatest(Types.AIRPORT_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParamsCameo(action.filters || {});
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(AirportService.getAirport, params);
        yield put(setListAirportsAction(result));
    }, errorHandleAirport(Types.AIRPORT_LIST_FAIL)))
}

function* getAirportDetail() {
    yield takeLatest(Types.AIRPORT_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(AirportService.getAirportDetail, action.id);
        yield put(setAirportDetailAction(result));
    }, errorHandleAirport(Types.AIRPORT_DETAIL_FAIL)))
}

function* updateAirportDetail() {
    yield takeLatest(Types.AIRPORT_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(AirportService.updateAirportDetail, action.airport.airport);
        yield call(AirportService.updateToAirportList, action.airport.airport.id, action.airport.selectedAirportCodes);
        successHandleAirport(action, action.airport.airport.name);
        yield put(setAirportDetailAction(action.airport.airport));
        history.push(PATHS.AIRPORT.LIST.path);
        history.go();
    }, errorHandleAirport(Types.AIRPORT_DETAIL_FAIL)))
}

function* createAirportDetail() {
    yield takeLatest(Types.AIRPORT_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        const result = yield call(AirportService.createAirportDetail, action.airport.airport);
        yield call(AirportService.createToAirportList, action.airport.airport.id, action.airport.selectedAirportCodes);
        successHandleAirport(action, action.airport.airport.name);
        yield put(setAirportDetailAction(result));
        history.push(PATHS.AIRPORT.LIST.path);
        history.go();
    }, errorHandleAirport(Types.AIRPORT_DETAIL_FAIL)))
}

function* deleteAirportDetail() {
    yield takeLatest(Types.AIRPORT_DETAIL_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(AirportService.deleteAirportDetail, action.airport);
        Func.sagaSuccessMessage({
            action,
            message: `${i18n.t('notification.removeSuccess')}`,
        });
        const params = parseListRequestParamsCameo(action.filter || {});
        const resultList = yield call(AirportService.getAirport, params);
        yield put(setListAirportsAction(resultList));
    }, errorHandleAirport(Types.AIRPORT_DETAIL_FAIL)));
}

function* getListAirlineDomestic() {
    yield takeLatest(Types.AIRLINE_LIST_DOMESTIC_ACTION, Func.sagaWrapper(function* (action) {
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(AirportService.getAirlineDomestic);
        yield put(setListAirlineDomestic(result?.data?.data));
    }, errorHandleAirport(Types.AIRLINE_LIST_DOMESTIC_FAIL)));
}

function* getListAirportDeparture() {
    yield takeLatest(Types.AIRPORT_LIST_DEPARTURE_ACTION, Func.sagaWrapper(function* (action) {
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(AirportService.getAirportDeparture);
        yield put(setListAirportDeparture(result.data.data));
    }, errorHandleAirport(Types.AIRPORT_LIST_DEPARTURE_FAIL)))
}

function* getListAirportArrival() {
    yield takeLatest(Types.AIRPORT_LIST_ARRIVAL_ACTION, Func.sagaWrapper(function* (action) {
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(AirportService.getAirportArrival);
        yield put(setListAirportArrival(result.data.data));
    }, errorHandleAirport(Types.AIRPORT_LIST_ARRIVAL_FAIL)))
}


/* Transtale Saga */

function* createAirportTranslate() {
    yield takeLatest(Types.AIRPORT_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(AirportService.createAirportTranslate, action.airport);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.airport.translate.languageName);
        yield put({ type: Types.AIRPORT_CREATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.AIRPORT_DETAIL_ACTION, id: action.airport.id });
    }, errorHandleAirport(Types.AIRPORT_FAIL)))
}

function* updateAirportTranslate() {
    yield takeLatest(Types.AIRPORT_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(AirportService.updateAirportTranslate, action.airport);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.airport.translate.languageName);
        yield put({ type: Types.AIRPORT_UPDATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.AIRPORT_DETAIL_ACTION, id: action.airport.id });
    }, errorHandleAirport(Types.AIRPORT_FAIL)))
}

function* deleteAirportTranslate() {
    yield takeLatest(Types.AIRPORT_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(AirportService.deleteAirportTranslate, action.airport.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.airport.translate.languageName);
        yield put({ type: Types.AIRPORT_DELETE_TRANSLATE_SUCCESS });
        yield put({ type: Types.AIRPORT_DETAIL_ACTION, id: action.airport.id });
    }, errorHandleAirport(Types.AIRPORT_FAIL)))
}

function* getToAirportList() {
    yield takeLatest(Types.TOAIRPORT_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(AirportService.getToAirportList, action.id);
        yield put(setToAirportList(result));
    }, errorHandleAirport(Types.TOAIRPORT_LIST_FAIL)))
}

function* createToAirportListRequest() {
    yield takeLatest(Types.TOAIRPORT_LIST_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(AirportService.createToAirportList, action.id, action.airportCodes);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'));
        yield put({ type: Types.TOAIRPORT_LIST_ACTION, id: action.id });
    }, errorHandleAirport(Types.AIRPORT_FAIL)))
}

function* updateToAirportListRequest() {
    yield takeLatest(Types.TOAIRPORT_LIST_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(AirportService.updateToAirportList, action.id, action.airportCodes);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.202'));
        yield put({ type: Types.TOAIRPORT_LIST_ACTION, id: action.id });
    }, errorHandleAirport(Types.AIRPORT_FAIL)))
}

function successHandleAirport(action, value) {
    return Func.sagaSuccessMessage({
        action,
        message: `${i18n.t('notification.createSuccess')}`,
        description: `${i18n.t('item.airport.title')} "${value}"`
    })
}


function errorHandleAirport(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'airport');
}

function* updateAirlineSource() {
    yield takeLatest(Types.AIRLINE_SOURCE_UPDATE, Func.sagaWrapper(function* (action) {
        yield call(AirportService.updateAirlineSource, action.params);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'));
        yield put({ type: Types.AIRLINE_SOURCE_UPDATE_SUCCESS });
        yield put(setAirlineSourceVJ(action.params.sourceCode));
    }, errorHandleAirport(Types.AIRPORT_FAIL)))
}
function* getAirlineSourceVJ() {
    yield takeLatest(Types.AIRLINE_SOURCE_GET, Func.sagaWrapper(function* () {
        const result = yield call(AirportService.getAirlineSourceVJ);
        yield put(setAirlineSourceVJ(result.sourceCode));
    }, errorHandleAirport(Types.AIRPORT_FAIL)))
}
export function* airportSaga() {
    yield all([
        fork(getListAirport),
        fork(getAirportDetail),
        fork(updateAirportDetail),
        fork(createAirportDetail),
        fork(createAirportTranslate),
        fork(updateAirportTranslate),
        fork(deleteAirportDetail),
        fork(deleteAirportTranslate),
        fork(getListAirlineDomestic),
        fork(getListAirportDeparture),
        fork(getListAirportArrival),
        fork(getToAirportList),
        fork(createToAirportListRequest),
        fork(updateToAirportListRequest),
        fork(getAirlineSourceVJ),
        fork(updateAirlineSource),
    ])
}
